export default "__VITE_ASSET__B4qrrUz1__"